import { LifeUpdater } from "./LifeUpdater";
export async function loadLifeUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("life", (container) => new LifeUpdater(container), refresh);
}
